import { render, staticRenderFns } from "./WhatsappIntegrationsModal.vue?vue&type=template&id=66d38838"
import script from "./WhatsappIntegrationsModal.vue?vue&type=script&lang=js"
export * from "./WhatsappIntegrationsModal.vue?vue&type=script&lang=js"
import style0 from "./WhatsappIntegrationsModal.vue?vue&type=style&index=0&id=66d38838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports